// extracted by mini-css-extract-plugin
export var active = "_35-2";
export var errorDot = "_35-3";
export var sideNavContainer = "_35-0";
export var sideNavLink = "_35-1";